import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            'change': {
                'select': 'onChange'
            }
        }
    }

    init() {
        this.urlParams = new URLSearchParams(window.location.search);
        this.isPast = this.urlParams.get('past');
        this.page = this.urlParams.get('page');
        this.location = this.urlParams.get('location');
        this.category = this.urlParams.get('category');

        const $scrollTarget = document.getElementById('eventListing') || this.el;

        if(
            (
            this.isPast ||
            this.location ||
            this.category ||
            this.page
            ) && $scrollTarget
        ) {
            this.call('scrollTo', { target: $scrollTarget, options: { offset: -84 } }, 'Scroll');
        }
    }

    onChange(e) {
        const url = e.currentTarget.value;
        this.call('goTo', url, 'Load');
    }
}
